import { sbaAxios } from "../utils/sbaAxios";
import { getAssetSettingsList } from "../../config/apiConfig";
import { getBenchmarkEntity } from "../../config/apiConfig";
import {
    FETCH_ASSETSETTINGS_BEGIN,
    FETCH_ASSETSETTINGS_SUCCESS,
    FETCH_ASSETSETTINGS_FAILURE,
    FETCH_BENCHMARKENTITIES_BEGIN,
    FETCH_BENCHMARKENTITIES_SUCCESS,
    FETCH_BENCHMARKENTITIES_FAILURE
} from '../constants/assetsettings';


export const getAssetSettings = (AssetID,EntityTypeID) => {
    return (dispatch) => {
        dispatch(fetchassetSettingsBegin());
        sbaAxios({
            url: `${getAssetSettingsList}${AssetID},${EntityTypeID}`,
            method: 'get',
        })
      
            .then((repos) => {
                const AssetSetting = repos;
                //Add logic to format the DataItem if needed using map
                dispatch(fetchassetSettingsSuccess(AssetSetting));
                return AssetSetting;
            })
            .catch((error) => dispatch(fetchassetSettingsFailure(error)));
    };
}

export const fetchassetSettingsBegin = () => ({
    type: FETCH_ASSETSETTINGS_BEGIN,
});

export const fetchassetSettingsSuccess = (settingsDetails) => ({
    type: FETCH_ASSETSETTINGS_SUCCESS,
    payload: { settingsDetails },
});


export const fetchassetSettingsFailure = (errorMessage) => ({
    type: FETCH_ASSETSETTINGS_FAILURE,
    payload: { errorMessage }
});


export const getBenchmarkEntities = (Searchterm,type) => {
    return (dispatch) => {
        dispatch(fetchassetSettingsBegin());
        sbaAxios({
            url: `${getBenchmarkEntity}${Searchterm}`,
            method: 'get',
        })
            .then((repos) => {
                const benchMarkEntities = repos;
                //Add logic to format the DataItem if needed using map
                dispatch(fetchBenchmarkEntitiesSuccess(benchMarkEntities,type));
                return benchMarkEntities;
            })
            .catch((error) => dispatch(fetchBenchmarkEntitiesFailure(error)));
    };
}

export const fetchBenchmarkEntitiesBegin = () => ({
    type: FETCH_BENCHMARKENTITIES_BEGIN,
});

export const fetchBenchmarkEntitiesSuccess = (benchMarkEntities,type) => ({
    type: FETCH_BENCHMARKENTITIES_SUCCESS,
    payload: { type:type,benchMarkEntities:benchMarkEntities },
});


export const fetchBenchmarkEntitiesFailure = (errorMessage) => ({
    type: FETCH_BENCHMARKENTITIES_FAILURE,
    payload: { errorMessage }
});

